export default {
	"f843939e3689bdd3f19f9546ad57d04c": "请选择可用优惠券",
	"a0ecec5b6e3c8bd5219bfa6651c495dd": "无可用优惠券",
	"35d266578bfc5804668c799e07c7a47e": "无可用代金券",
	"aa9b2436d91ba608dd82d616b6a564b9": "请选择可用代金券",
	"aa57cab48b8dd60903b3f215a35f8bd2": "商品价格",
	"5a5cc12eeef86e20f511c5e9c749b5f6": "优惠金额",
	"e524e2c0fcb17d7b2b1c58becc73cde1": "优惠券",
	"3d8680f7ff1d0bb9c764d68cf70dfb3e": "代金券",
	"d55e93e26c8639a968b3da4b11ec1cac": "已优惠",
	"a59d355d26a255a6210028b4f7385f0f": "合计",
	"fac3670cf24e7bebc5fa8a4fd98c6f8f": "签约价"
}
